import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { checkSMSCode, loginSMS } from '@/api/shortMsg'

const user = {
  state: {
    token: getToken(),
    id: '',
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    changePwd: true
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_CHANGE_PWD: (state, changePwd) => {
      state.changePwd = changePwd
    }
  },

  actions: {
    // 设置Token
    SetToken({ commit, dispatch }, token) {
      commit('SET_TOKEN', token)
      if (token) {
        setToken(token)
        dispatch('GetInfo')
      } else {
        removeToken()
      }
    },

    // 登录
    Login({ commit, dispatch }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const rememberPwd = userInfo.rememberPwd
      const code = userInfo.code
      const uuid = userInfo.uuid
      const clientType = userInfo.clientType
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid, clientType).then(res => {
          dispatch('SetToken', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 短信登录
    LoginWithSMS({ commit, dispatch }, userInfo) {
      const username = userInfo.username.trim()
      const code = userInfo.validateCode
      const clientType = userInfo.clientType
      return new Promise((resolve, reject) => {
        loginSMS({ phoneNum: username, code, clientType }).then(res => {
          dispatch('SetToken', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user
          const avatar = user.avatar;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_ID', user.userId)
          commit('SET_NAME', user.nickName)
          commit('SET_AVATAR', avatar)
          dispatch('SetChangePwd', user.changePwd)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          dispatch('SetToken', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          dispatch('SetChangePwd', true)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit, dispatch }) {
      return new Promise(resolve => {
        dispatch('SetToken', '')
        resolve()
      })
    },

    // 设置是否修改密码
    SetChangePwd({ commit }, changePwd) {
      commit('SET_CHANGE_PWD', changePwd)
    }
  }
}

export default user
